// extracted by mini-css-extract-plugin
export default {"p":"b9ce8efe7a _54e2f2976f _4af8321838","clr":"_6d36b8e5d1","dls":"_2fde6326d0"};